import React from 'react';
import { XIcon } from 'lucide-react';
export const TraditionalMethodsSection = () => {
  const failedMethods = [{
    title: 'Nowa bielizna i ubrania',
    description: 'Krótkotrwały efekt, który szybko przestaje działać. Mąż przyzwyczaja się do nowego wyglądu, a problem pozostaje.'
  }, {
    title: 'Więcej dbania o dom i rodzinę',
    description: 'Zwiększa Twoją niewidzialność. Stajesz się jeszcze bardziej funkcją, a nie kobietą w jego oczach.'
  }, {
    title: 'Rozmowy i prośby o uwagę',
    description: 'Prowadzą do większego wycofania się męża. Czuje się oskarżany i atakowany, więc buduje mur.'
  }, {
    title: 'Romantyczna kolacja i świece',
    description: 'Jednorazowy gest, który nie rozwiązuje głębszego problemu. Następnego dnia wszystko wraca do punktu wyjścia.'
  }, {
    title: 'Terapia małżeńska',
    description: 'Działa tylko wtedy, gdy oboje są zaangażowani. Większość mężczyzn odmawia udziału lub uczestniczy bez przekonania.'
  }];
  return <section className="w-full bg-white py-16 px-4 md:px-8 lg:px-16" data-id="element-208">
      <div className="max-w-6xl mx-auto" data-id="element-209">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-800 mb-6 text-center" data-id="element-210">
          Dlaczego tradycyjne metody zawodzą?
        </h2>
        <p className="text-lg text-gray-700 mb-10 text-center max-w-3xl mx-auto" data-id="element-211">
          Być może próbowałaś już różnych sposobów, by odzyskać uwagę i
          pożądanie męża. Oto dlaczego większość z nich nie działa:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-212">
          {failedMethods.map((method, index) => <div key={index} className="bg-[#faf7f2] border border-gray-200 rounded-lg p-6 relative" data-id="element-213">
              <div className="absolute top-4 right-4 bg-red-500 rounded-full p-1 text-white" data-id="element-214">
                <XIcon size={20} data-id="element-215" />
              </div>
              <h3 className="font-serif text-xl font-bold text-gray-800 mb-3" data-id="element-216">
                {method.title}
              </h3>
              <p className="text-gray-700" data-id="element-217">{method.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};